import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
import { FIB } from '@/config/constants';
import { version } from "../../package.json";
import FibConnectivity from '@/components/Connectivity';
import FibUpdateState from '@/components/UpdateState';
var US = FIB.US; // Use constants for Update States

export default {
  name: 'FibAppStatusInfo',
  components: {
    FibConnectivity: FibConnectivity,
    FibUpdateState: FibUpdateState
  },
  data: function data() {
    return _objectSpread(_objectSpread({}, US), {}, {
      updateInProgress: false,
      version: version
    });
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, get('config', {
    lastUpdated: 'lastUpdated',
    configUpdateState: 'updateState'
  })), get('responses', {
    completedSurveyCount: 'responsesTemp.length',
    questionsSaved: 'response.answers.length',
    responsesUpdateState: 'updateState'
  })), get('surveys', {
    surveyUpdateState: 'updateState'
  })), get('surveys', ['questionCount', 'surveys', 'surveyInProgress'])), {}, {
    questionsProgress: function questionsProgress() {
      return this.questionsSaved / this.questionCount(this.surveyInProgress);
    }
  })
};